'use client';
import AppLayout from '@/components/AppLayout';
import SupplierReportsContent from './components/SupplierReportsContent';

export default function SupplierReportsPage() {
  return (
    <AppLayout>
      <SupplierReportsContent />
    </AppLayout>
  );
}
